import React from 'react';

const Wallet = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.72 3.51996H1.92C1.75026 3.51996 1.58748 3.45253 1.46745 3.33251C1.34743 3.21249 1.28 3.0497 1.28 2.87996C1.28 2.71022 1.34743 2.54744 1.46745 2.42741C1.58748 2.30739 1.75026 2.23996 1.92 2.23996H12.8C12.9697 2.23996 13.1325 2.17253 13.2525 2.05251C13.3726 1.93249 13.44 1.7697 13.44 1.59996C13.44 1.43022 13.3726 1.26744 13.2525 1.14741C13.1325 1.02739 12.9697 0.959961 12.8 0.959961H1.92C1.41078 0.959961 0.922425 1.16225 0.562355 1.52232C0.202285 1.88239 0 2.37075 0 2.87996V13.12C0 13.6292 0.202285 14.1175 0.562355 14.4776C0.922425 14.8377 1.41078 15.04 1.92 15.04H14.72C15.0595 15.04 15.385 14.9051 15.6251 14.6651C15.8651 14.425 16 14.0994 16 13.76V4.79996C16 4.46048 15.8651 4.13491 15.6251 3.89486C15.385 3.65482 15.0595 3.51996 14.72 3.51996ZM14.72 13.76H1.92C1.75026 13.76 1.58748 13.6925 1.46745 13.5725C1.34743 13.4525 1.28 13.2897 1.28 13.12V4.69036C1.4855 4.76321 1.70197 4.80028 1.92 4.79996H14.72V13.76ZM10.88 8.95996C10.88 8.77009 10.9363 8.58448 11.0418 8.42661C11.1473 8.26874 11.2972 8.1457 11.4726 8.07304C11.648 8.00038 11.8411 7.98137 12.0273 8.01841C12.2135 8.05545 12.3846 8.14688 12.5188 8.28114C12.6531 8.4154 12.7445 8.58645 12.7816 8.77267C12.8186 8.9589 12.7996 9.15192 12.7269 9.32734C12.6543 9.50275 12.5312 9.65269 12.3733 9.75817C12.2155 9.86366 12.0299 9.91996 11.84 9.91996C11.5854 9.91996 11.3412 9.81882 11.1612 9.63878C10.9811 9.45875 10.88 9.21457 10.88 8.95996Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Wallet;
